const model_img = () => {

    let $item = $('#model');
    let item_id = $item.data('id');
    let frame_to_roll = $item.data('frame-to-roll');
    let frame_from_roll = $item.data('frame-from-roll');
    let invert_controls = Boolean($item.data('invert'));
    let invert_auto_rotation = Boolean($item.data('invert-auto-rotation'));
    let images_path = '/wp-content/themes/classy/assets/models/360/' + item_id + '/';
    let total_frames = $item.data('model-frames-count');
    let current_frame = 0;
    let preloaded = [];
    let new_frame;
    let frame_img;
    let pressedX = 0;
    let down = false;
    let container_img = $item.children('img');
    let sensibility = 1;
    let moved_times = 0;
    let pageX = 0;
    let events = {};
    let $loader = $('#ajax-model-loader');

    if($(window).width() >= 1200) {
        events = {
            down: 'mousedown',
            move: 'mousemove',
            up: 'mouseup'
        };
    }
    else {
        events = {
            down: 'touchstart',
            move: 'touchmove',
            up: 'touchend'
        };
    }


    if(typeof item_id !== "undefined" && item_id !== null && item_id) {

        $item.on(events.down, function (e) {

            e.preventDefault();
            pressedX = ('touchstart' === e.type) ? e.originalEvent.touches[0].pageX : e.pageX;
            pageX = pressedX;

            down = true;
        });

        $item.on(events.move, function (e) {

            e.preventDefault();

            if(down === true) {

                moved_times++;

                if(moved_times % sensibility === 0) {

                    let currentX = ('touchmove' === e.type ? e.originalEvent.touches[0].pageX : e.pageX);

                    if(invert_controls) {
                        currentX = currentX * -1;
                    }

                    if(pageX - currentX > 0) {
                        new_frame = current_frame - 1;
                    }
                    else {
                        new_frame = current_frame + 1;
                    }

                    if(new_frame < 0) {
                        new_frame = (total_frames + new_frame) - 1;
                    }
                    else if (new_frame > total_frames - 1) {
                        new_frame = 0;
                    }

                    pageX = currentX;

                    current_frame = new_frame;

                    container_img.attr('src', preloaded[new_frame].src);

                }

            }

        });

        $(document).on(events.up, function () {
            down = false;
        });

        let start = 0;
        let i = 0;
        let frames_count = 0;

        frames_count = (frame_to_roll - frame_from_roll) > 0 ? (frame_to_roll - frame_from_roll) : (frame_to_roll - frame_from_roll) + total_frames;

        if(invert_auto_rotation) {
            frames_count = (frames_count - total_frames) * -1;
        }

        if(frame_from_roll > 0) {
            start = frame_from_roll;
        }
        else {
            start = frame_to_roll > 30 ? (frame_to_roll - 15) : 0;
            frames_count = 15;
        }

        $(window).on('load',function () {

            setTimeout(function () {

                $loader.removeClass('active');

                let current = start;

                let interval = setInterval(function () {

                    if(i >= frames_count) {
                        clearInterval(interval);
                    }

                    else {

                        i++;

                        invert_auto_rotation ? current-- : current++;

                        if(!invert_auto_rotation) {
                            if(current >= total_frames) {
                                current = 0;
                            }
                        }
                        else {
                            if(current <= 0) {
                                current = total_frames;
                            }
                        }

                        current_frame = current;
                        container_img.attr('src', preloaded[current].src);
                        add_shades();

                    }

                }, 60);
            },1500);
        });


        for (let i = 0; i < total_frames; i++) {
            preloaded[i] = new Image();
            preloaded[i].frame = i;
            frame_img = (i < 10 ? '00' : (i < 100 ? '0' : '')) + i + '.jpg';
            preloaded[i].src = images_path + frame_img;
        }
    }

    function add_shades() {
        const product_overview = $('.js-product-overview');

        product_overview.each(function () {
            let ths = $(this);

            let overview_image = ths.children('img');
            let overview_image_ovelay = ths.find('.js-img-overlay');

            let img_w = overview_image.width();
            let img_h = overview_image.height();

            let interval = setInterval(function () {

                if(overview_image_ovelay.hasClass('ready')){
                    clearInterval(interval);
                }
                else {
                    overview_image_ovelay.css({
                        'width' : (img_w + 5) + 'px',
                        'height' : (img_h  + 2) + 'px'
                    }).addClass('ready');
                }

            });


            $(window).resize(function () {
                let img_w = overview_image.width();
                let img_h = overview_image.height();

                overview_image_ovelay.css({
                    'width' : (img_w + 5) + 'px',
                    'height' : (img_h  + 2) + 'px'
                });
            });
        })
    }

};

export default model_img;
